import api from './config';

/**
 * 获取设备角色配置记录列表
 * @param {Object} params 查询参数
 */
export function getDeviceRoleSettings(params = {}) {
  return api.get('/device_role_setting', { params });
}

/**
 * 获取设备角色配置记录详情
 * @param {string} id 设备角色配置记录ID
 */
export function getDeviceRoleSettingById(id) {
  return api.get(`/device_role_setting/${id}`);
}

/**
 * 记录设置为已处理
 */
export function setDeviceRoleSettingAsHandled(id) {
  return api.post(`/device_role_setting/${id}/handled`);
}

/**
 * 获取未处理总数
 */
export function getUnhandledCount() {
  return api.get('/device_role_setting/unhandled_count');
}